export default "__VITE_ASSET__aysmuoEf__"